import React from "react";

import { t } from "i18next";

import { useWorkspaceParam } from "@/hooks/useWorkspaceParam";

import { WorkspacePicker } from "@/components/organisms";
import { SubscriptionSection } from "@/components/organisms/SubscriptionSection/SubscriptionSection";
import { PageLayout } from "@/components/templates";

import { MANAGING_ROLES } from "@/utils/UWorkspaces";

/**
 * /subscription: a workspace's plan, its usage, and the plans on offer -
 * the user's own, or another they run (`?workspace=`, picked at the top).
 */
export const Subscription: React.FC = () => {
	const { workspaceId, current, options, select } =
		useWorkspaceParam(MANAGING_ROLES);

	return (
		<PageLayout title={t("subscription.title")}>
			<WorkspacePicker
				options={options}
				value={current?.id}
				onChange={select}
				className="mb-6"
			/>
			<SubscriptionSection
				key={workspaceId ?? "own"}
				workspaceId={workspaceId}
			/>
		</PageLayout>
	);
};
